'use client';

import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { printJobService } from '@/lib/supabaseService';

const ConsumptionChart = dynamic(() => import('./ConsumptionChart'), { ssr: false });
const MaterialChart = dynamic(() => import('./MaterialChart'), { ssr: false });

interface ConsumptionPoint { date: string; ml: number; jobs: number; }
interface MaterialPoint { material: string; jobs: number; ml: number; }

export default function DashboardCharts() {
  const [consumptionData, setConsumptionData] = useState<ConsumptionPoint[]>([]);
  const [materialData, setMaterialData] = useState<MaterialPoint[]>([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState('');

  useEffect(() => {
    printJobService.getChartData().then(({ consumptionData: cd, materialData: md }) => {
      setConsumptionData(cd);
      setMaterialData(md);
      if (cd.length >= 2) {
        setDateRange(`${cd[0].date} — ${cd[cd.length - 1].date}`);
      }
      setLoading(false);
    });
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
      {/* Consumption area chart — wider */}
      <div className="lg:col-span-3 rounded-xl p-5 border" style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600" style={{ color: 'var(--foreground)' }}>Consommation résine</h3>
            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>14 derniers jours — mL</p>
          </div>
          {dateRange && (
            <span className="text-xs px-2 py-1 rounded-md" style={{ backgroundColor: 'var(--muted)', color: 'var(--muted-foreground)' }}>
              {dateRange}
            </span>
          )}
        </div>
        {loading ? (
          <div className="h-[200px] rounded-lg animate-pulse" style={{ backgroundColor: 'var(--muted)' }} />
        ) : (
          <ConsumptionChart data={consumptionData} />
        )}
      </div>

      {/* Material bar chart */}
      <div className="lg:col-span-2 rounded-xl p-5 border" style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600" style={{ color: 'var(--foreground)' }}>Par matériau</h3>
            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>Impressions totales</p>
          </div>
        </div>
        {loading ? (
          <div className="h-[200px] rounded-lg animate-pulse" style={{ backgroundColor: 'var(--muted)' }} />
        ) : materialData.length === 0 ? (
          <div className="h-[200px] flex items-center justify-center">
            <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>Aucune donnée disponible</p>
          </div>
        ) : (
          <MaterialChart data={materialData} />
        )}
      </div>
    </div>
  );
}